import { Column, Row, SeparatorLine, Txt } from "@stenajs-webui/core";
import type { FC, ReactNode } from "react";

import { Colors } from "../colors";
import { formatDateTime, resolveDateFormat } from "../utils/dates/dateUtils";

export interface ErrorCardProps {
  content?: ReactNode;
  title: ReactNode;
}

export const ErrorCard: FC<ErrorCardProps> = ({ content, title }) => (
  <Column background={Colors.UI8} shadow={"box"} width={960} maxWidth={960}>
    <Row spacing={2} indent={2} justifyContent={"space-between"}>
      <Txt>{title}</Txt>
      <Txt>{formatDateTime(new Date(), resolveDateFormat())}</Txt>
    </Row>
    <SeparatorLine />
    <Row spacing={2} indent={2}>
      {content}
    </Row>
  </Column>
);
